import React, { useState, useEffect, useRef } from "react";
import HomeService from "../../../Services/HomeService"; // Assuming you use HomeService for data fetching
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function AddAdvertisement() {
  const [userId, setUserId] = useState("");
  const [advertiseName, setAdvertiseName] = useState("");
  const [logo, setLogo] = useState("");
  const [image, setImage] = useState("");
  const [businessField, setBusinessField] = useState([]);
  const [majorLocality, setMajorLocality] = useState("");
  const [workExp, setWorkExp] = useState("");
  const [userList, setUserList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  const [amount, setAmount] = useState(0)
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState("")
  const [remarks, setRemarks] = useState("")

  const navigate = useNavigate();

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("HYT31", res.data);

      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
          setSelectedCity(userCity)
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  useEffect(() => {
    fetchCities();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const usersResponse = await HomeService.getUsers();
        const citiesResponse = await HomeService.getCities();

        if (usersResponse?.status) {
          setUserList(usersResponse?.data || []);
        }

        if (citiesResponse?.status) {
          setCityList(citiesResponse?.data || []);
        }
      } catch (error) {
        toast.error("Failed to fetch users or cities.");
        console.error(error);
      }
    };

    fetchData();

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      // userId,
      // advertiseName,
      // logo,
      // image,
      // businessField,
      // majorLocality,
      // workExp: parseInt(workExp, 10),

      userId,
      advertiseName,
      logo,
      image,
      businessField: [selectedCity],
      city: [selectedCity],
      majorLocality,
      workExp: parseInt(workExp, 10),
      amount: parseInt(amount),
      startDate: startDate.split("T")[0],
      endDate: endDate.split("T")[0],
      date: date.split("T")[0],
      remarks: remarks,
      addedBy: loggedUserID,
    };

    console.log("UY115", data);
    // return

    try {
      const res = await HomeService.addAdvertisement(data); // Replace with your API call
      if (res?.status) {
        toast.success("Advertisement added successfully!");
        clearForm();
        navigate("/manage-advertisement"); // Replace with appropriate route
      }
    } catch (error) {
      toast.error("Failed to add advertisement.");
      console.error(error);
    }
  };

  const clearForm = () => {
    setUserId("");
    setAdvertiseName("");
    setLogo("");
    setImage("");
    setBusinessField([]);
    setMajorLocality("");
    setWorkExp("");
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setBusinessField((prev) =>
      prev.includes(value)
        ? prev.filter((id) => id !== value)
        : [...prev, value]
    );
  };

  const handleFileUpload = async (e, type) => {
    const file = e.target.files[0];
    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.status) {
        if (type === "logo") {
          setLogo(res.image || "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/5616ed80-da40-11ef-b071-93ec841e19cd.png");
          toast.success("Logo uploaded successfully!");
        } else if (type === "image") {
          setImage(res.image || "https://webhibes3bucket1.s3.ap-south-1.amazonaws.com/image/661d40d0-da40-11ef-b071-93ec841e19cd.jpg");
          toast.success("Image uploaded successfully!");
        }
      }
    } catch (error) {
      toast.error(`Failed to upload ${type}.`);
      console.error(`Error uploading ${type}:`, error);
    }
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle}>Add Advertisement</div>
          <hr />
          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  <select
                    id="user"
                    className="form-control"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    required
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName} - {user.email}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="advertiseName">
                    Advertisement Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="advertiseName"
                    className="form-control"
                    value={advertiseName}
                    onChange={(e) => setAdvertiseName(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  {logo ? (
                    <>
                      <img
                        src={logo}
                        alt="Logo Preview"
                        style={{ display: "block", marginTop: "10px", maxHeight: "100px", marginBottom: "1em" }}
                      />
                    </>
                  ) : (
                    <label htmlFor="logo">
                      Upload Logo<span className="text-danger">*</span>
                    </label>
                  )}
                  <input
                    type="file"
                    name="logo"
                    id="logo"
                    className="form-control"
                    onChange={(e) => handleFileUpload(e, "logo")}
                    accept="image/*"
                    required
                  />
                </div>


                <div className="col-md-6 mt-3">
                  {image ? (
                    <>
                      <img
                        src={image}
                        alt="Image Preview"
                        style={{ display: "block", marginTop: "10px", maxHeight: "100px", marginBottom: "1em" }}
                      />
                    </>
                  ) : (
                    <label htmlFor="image">
                      Upload Image<span className="text-danger">*</span>
                    </label>
                  )}
                  <input
                    type="file"
                    name="image"
                    id="image"
                    className="form-control"
                    onChange={(e) => handleFileUpload(e, "image")}
                    accept="image/*"
                    required
                  />
                </div>


                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    City<span className="text-danger">*</span>
                  </label>
                  {/* <div className="dropdown" ref={dropdownRef}>
                  <button
                    type="button"
                    className="form-control"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    {businessField.length === 0
                      ? "Select Cities"
                      : `${businessField.length} cities selected`}
                  </button>
                  {isDropdownOpen && (
                    <div className="dropdown-menu-for-city">
                      {cityList.map((city) => (
                        <div key={city._id} className="form-check">
                          <input
                            type="checkbox"
                            id={`city-${city._id}`}
                            value={city._id}
                            checked={businessField.includes(city._id)}
                            onChange={handleCityChange}
                            className="form-check-input"
                          />
                          <label
                            htmlFor={`city-${city._id}`}
                            className="form-check-label"
                          >
                            {city.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div> */}
                  <select
                    className="form-control"
                    value={selectedCity}
                    onChange={(e) => setSelectedCity(e.target.value)}
                  >
                    <option value="" disabled>---Select---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="majorLocality">
                    Major Locality<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="majorLocality"
                    className="form-control"
                    value={majorLocality}
                    onChange={(e) => setMajorLocality(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="workExp">
                    Amount<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="workExp"
                    className="form-control"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="workExp">
                    Work Experience (Years)<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="workExp"
                    className="form-control"
                    value={workExp}
                    onChange={(e) => setWorkExp(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Remarks
                  </label>
                  {/* <input
                  type="text"
                  id="endDate"
                  className="form-control"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                /> */}
                  <textarea
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>
              </div>

              <button type="submit" style={{
                background: 'rgb(133, 218, 79)',
                borderRadius: '13px'
              }} className="btn mt-3">
                Add Advertisement
              </button>
              <button type="submit" style={{
                background: '#fff',
                border:"solid 2px #85da4f",
                borderRadius: '13px',
                margin:'0 10px'
              }} className="btn mt-3"
                onClick={()=>{ navigate("/manage-advertisement")} }
              >
                View Advertisements
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddAdvertisement;
